import React, { Suspense } from "react";
import { IntlProvider } from "react-intl";
import { PrimeReactProvider } from "primereact/api";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import "primeicons/primeicons.css";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/app.scss";
import { ToastContainer } from "react-toastify";
import ErrorBoundary from "./components/common/errorBoundary";
import { configureReduxStore } from "./store/configureStore";
import Routes from "./routes";
import messages from "./i18n";
import { locale, defaultLocale } from "./i18n/intl";
import DomainHandler from "./DomainHandler";
import BrandApplicator from "./BrandApplicator";

const store = configureReduxStore();

function App() {
  const [isAppReady, setIsAppReady] = React.useState(false);

  return (
    <IntlProvider
      locale={locale}
      messages={messages[locale] || messages[defaultLocale]}
    >
      <Router>
        <ErrorBoundary>
          <PrimeReactProvider>
            <Provider store={store}>
              <BrandApplicator />
              <div className="edexlms-app">
                <Suspense
                  fallback={<div className="edexlms-suspense">Loading...</div>}
                >
                  <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    theme="colored"
                    hideProgressBar={true}
                  />
                  {(isAppReady && <Routes />) || (
                    <DomainHandler
                      isAppReady={isAppReady}
                      setIsAppReady={setIsAppReady}
                    />
                  )}
                </Suspense>
              </div>
            </Provider>
          </PrimeReactProvider>
        </ErrorBoundary>
      </Router>
    </IntlProvider>
  );
}

export default App;
